import SEO from '@/components/shared/SEO';
import { heroImages } from '@/data/images';

export default function PrivacyPolicy() {
  return (
    <div data-testid="privacy-policy-page">
      <SEO
        title="Privacy Policy"
        description="Read Trademark Pact's privacy policy to understand how we collect, use, and protect your personal information when using our trademark registration services."
      />
      <section className="relative pt-28 pb-12 lg:pt-36 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src={heroImages.privacy} alt="" className="w-full h-full object-cover" loading="eager" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#064E3B]/95 via-[#064E3B]/85 to-[#064E3B]/70" />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-white tracking-tight mb-4">Privacy Policy</h1>
          <p className="text-emerald-200 text-sm">Last updated: January 2025</p>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate max-w-none">
          <div className="space-y-8 text-sm text-slate-600 leading-relaxed">
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Introduction</h2>
              <p>Trademark Pact ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this policy carefully. By using our website and services, you consent to the data practices described in this policy.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Information We Collect</h2>
              <p className="mb-3">We may collect personal information that you voluntarily provide when using our services, including:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Name, email address, and phone number</li>
                <li>Business name and trademark information</li>
                <li>Payment and billing information</li>
                <li>Communication records and correspondence</li>
                <li>IP address and geolocation data</li>
                <li>Browser type, device information, and usage data</li>
              </ul>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">How We Use Your Information</h2>
              <p className="mb-3">We use the collected information for various purposes, including:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Providing, maintaining, and improving our services</li>
                <li>Processing your trademark applications and filings</li>
                <li>Communicating with you regarding your applications and services</li>
                <li>Sending administrative information and service updates</li>
                <li>Responding to your inquiries and providing customer support</li>
                <li>Analyzing usage patterns to improve our website and services</li>
                <li>Complying with legal obligations and protecting our rights</li>
              </ul>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Data Security</h2>
              <p>We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Third-Party Sharing</h2>
              <p>We do not sell your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website and providing our services, subject to confidentiality agreements. We may also disclose information when required by law or to protect our legal rights.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Cookies and Tracking</h2>
              <p>We use cookies and similar tracking technologies to enhance your experience on our website. You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. If you disable cookies, some features of our website may not function properly.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Your Rights</h2>
              <p className="mb-3">Depending on your jurisdiction, you may have the right to:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Access your personal information</li>
                <li>Correct inaccurate or incomplete information</li>
                <li>Request deletion of your personal information</li>
                <li>Object to or restrict certain processing activities</li>
                <li>Request portability of your personal data</li>
              </ul>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. Your continued use of our services after any modifications indicates your acceptance of the updated policy.</p>
            </div>
            <div>
              <h2 className="font-heading font-bold text-xl text-[#064E3B] mb-3">Contact Us</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at info@trademarkpact.com.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
